import { memo } from "react";

import type { FieldValue } from "../../../types";
import type { BaseFieldProps } from "../BaseField";

import { DynamicChangeSingleSelectFieldContainer } from "./DynamicChangeSingleSelectField.container";
import { DynamicSingleSelectFieldContainer } from "./DynamicSingleSelectField.container";
import type { FieldCode } from "./useFieldDependencyResolve";

interface DynamicSelectFieldContainerProps extends BaseFieldProps {
  /** フィールドのタイプ */
  type: "SingleSelect" | "ChangeSingleSelect";
  /** 依存元フィールドのコード */
  sourceFieldCode: FieldCode;
  /** 依存先フィールドのコード */
  targetFieldCode: FieldCode;
  /** フォーム内のすべてのフィールド値（依存元の値を取得するため） */
  allValues?: FieldValue[];
}

/**
 * 動的セレクトフィールドのファクトリーコンテナ
 */
export const DynamicSelectFieldContainer = memo(
  ({ type, ...props }: DynamicSelectFieldContainerProps) => {
    if (type === "ChangeSingleSelect") {
      return <DynamicChangeSingleSelectFieldContainer {...props} />;
    }

    return <DynamicSingleSelectFieldContainer {...props} />;
  },
);

DynamicSelectFieldContainer.displayName = "DynamicSelectFieldContainer";
